/* eslint react-hooks/rules-of-hooks: "off" */
import EnumBase from './Base';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();
  const trAddon = (addonType) => t(`${addonType}`);
  return new EnumBase([
    { name: trAddon('key_before_attendant'), id:'key_before_attendant' },
    { name: trAddon('key_before_doctor'), id:'key_before_doctor' },
  ]);
};
